import React from 'react';
import { StyledMainNav } from '../../style/MainMenu.styled';
import { NavLoginLink } from '../../../LoginLink/components/NavLoginLink';
import { SubscriptionButton } from '../../../ButtonLink/components/SubscriptionLink';
import { SubscriptionFares } from '../../../../lib/enums';

export const MainNav = () => {
    return (
        <StyledMainNav>
            <SubscriptionButton
                text="Оформить подписку"
                type={SubscriptionFares.MONTH}
            />
            <ul>
                <li>
                    <a href="#fare-section">Тарифы</a>
                </li>
                <li>
                    <a href="#reasons-section">Зачем нужна подписка</a>
                </li>
                <li>
                    <a href="#how-to-section">Как оформить</a>
                </li>
            </ul>
            <NavLoginLink />
        </StyledMainNav>
    );
};
